import { EnquiryColumnSearchComponent } from './enquiry-column-search/enquiry-column-search.component';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { TextTruncateComponent } from '@otas/shared/util/text-truncate/text-truncate.component';
import { PrintElementDirective } from '@otas/shared/util/print-directive';
import { PaginationComponent } from '@otas/shared/pagination/pagination.component';
import { ReportHeaderComponent } from '@otas/shared/report-header/report-header.component';
import { ConfirmModal, ConfirmModalService } from '@otas/shared/confirm-modal/confirm-modal.component';
import { UtilsModule } from '@otas/utils/utils.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DateTimeModule } from '@otas/utils/custom-components/datetime-component/datetime.module';
import { PaginationService } from '@otas/shared/pagination/pagination.service';
import { TransactionModalComponent } from './transaction-modal/transaction-modal.component';
import { TransactionModalService } from './transaction-modal/transaction-modal.service';
import { PdfGlyphsService } from '@otas/utils/pdf-glyphs/pdf-glyphs.service';
import { PdfGeneratorService } from '@otas/stoda/helper-services/pdf-generator.service';
import { AddOrUpdateAccHeadModalService } from '@otas/account-head/add-or-update-acc-head-modal/add-or-update-acc-head-modal.service';
import { AddOrUpdateAccHeadModalComponent } from '@otas/account-head/add-or-update-acc-head-modal/add-or-update-acc-head-modal.component';
import { AddPaymentModalComponent } from '@otas/stoda/expense-billing-stoda/add-payment-modal/add-payment-modal.component';
import { AddPaymentModalService } from '@otas/stoda/expense-billing-stoda/add-payment-modal/add-payment-modal.service';
import { ProductModalComponent } from '@otas/stoda/expense-billing-stoda/product-modal/product-modal.component';
import { VendorComponent } from '@otas/stoda/expense-billing-stoda/vendor/vendor.component';
import { VenderService } from '@otas/stoda/expense-billing-stoda/vendor/vendorService.service';
import { FilesService } from '@otas/shared/files.service';
import { EditAvatarComponent } from '@otas/membership/edit-avatar/edit-avatar.component';
import { ReportFooterComponent } from '@otas/shared/report-footer/report-footer.component';
import { ProgressBarService } from './progress-bar/progress-bar.service';
import { AutoCompleteModule } from '@otas/utils/custom-components/auto-complete/auto-complete.module';
import { SanitizePipe } from './pipes/sanitize.pipe';
import { ReportTableDirective } from './report-header/report-table.directive';
import { SlidepanelComponent } from "@otas/pooja-booking/pooja-booking-stoda/slidepanel/slidepanel.component";
import { InvoiceModalComponent } from '@otas/pooja-booking/invoice-modal/invoice-modal.component';
import { SortByPipe } from '@otas/pooja-shared/pipes/sort-by.pipe';

import { TimePickerComponent } from '@otas/shared/time-picker/time-picker.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { AddMemberModalComponent } from '@otas/membership/add-member-modal/add-member-modal.component';
import { AddMemberModalService } from '@otas/membership/add-member-modal/add-member-modal.service';
import { DownloadElementDirective } from '@otas/shared/util/download-directive';

export const SHARED_DECLARATIONS = [
  TextTruncateComponent, SanitizePipe, SortByPipe,
  PrintElementDirective,
  DownloadElementDirective,
  PaginationComponent,
  ReportHeaderComponent,
  TransactionModalComponent, ReportTableDirective,
  ConfirmModal,
  ReportFooterComponent,
  AddPaymentModalComponent, ProductModalComponent, VendorComponent, EditAvatarComponent, SlidepanelComponent,
  InvoiceModalComponent, TimePickerComponent, EnquiryColumnSearchComponent, AddMemberModalComponent
];
export const SHARED_MODULES = [
  UtilsModule,
  AutoCompleteModule,
  FormsModule,
  RouterModule, PdfViewerModule,
  ReactiveFormsModule,
  DateTimeModule

];
export const SHARED_EXPORT_MODULES = [
  UtilsModule,
  AutoCompleteModule,
  FormsModule, PdfViewerModule,
  RouterModule,
  ReactiveFormsModule,
  DateTimeModule
];
export const EXPORT_ITEMS = [...SHARED_EXPORT_MODULES, ...SHARED_DECLARATIONS];
export const SHARED_PROVIDERS = [PaginationService, AddOrUpdateAccHeadModalService, AddPaymentModalService, ProgressBarService, AddMemberModalService,
  ConfirmModalService, TransactionModalService, PdfGeneratorService, PdfGlyphsService, VenderService, FilesService];
export const SHARED_ENTRY_COMPONENTS = [ConfirmModal, TransactionModalComponent,
  AddOrUpdateAccHeadModalComponent, AddPaymentModalComponent, ProductModalComponent, VendorComponent, InvoiceModalComponent
  , EnquiryColumnSearchComponent];

@NgModule({
  imports: [
    SHARED_MODULES, AddOrUpdateAccHeadModalComponent
  ],
  declarations: [SHARED_DECLARATIONS, ProgressBarComponent],
  exports: [
    ...SHARED_EXPORT_MODULES,
    ...SHARED_DECLARATIONS,
    ProgressBarComponent
  ]
})
export class SharedModule {
  constructor() {
  }
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [SHARED_PROVIDERS]
    };
  }
}
